import { Route } from 'types/route.type';

import ListSites from './list-sites';
import ViewSite from './view-site';

export const routes: Route[] = [
  {
    path: '/site-settings/:siteTab?',
    component: ListSites,
    id: 'features.siteSettings',
  },
  {
    path: '/site-settings/sites/:globalSiteId/:siteTab',
    component: ViewSite,
  },
];
